import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  template: `
    <div>
      <time class="block text-sm leading-6 text-muted-color"
        >Stand 16.01.2024
      </time>

      <h2 class="text-lg mt-2 font-semibold text-gray-900">Präambel</h2>

      <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
        <li>
          Die BinDoc GmbH hat die Anwendung BinDoc Meta mit dem Analyse Modul
          Cube sowie weitere Softwarelösungen entwickelt, um Leistungserbringern
          im Gesundheitswesen eine softwarebasierte Datenanalysetechnik für die
          strategische und operative Entscheidungsfindung bereitzustellen.
          Darüber hinaus bietet die Softwarelösungen der BinDoc GmbH den
          Lizenznehmern (Leistungserbringer und andere Unternehmen im
          Gesundheitssektor) die Möglichkeit einer anonymisierten Auswertung der
          anonymisiert eingelieferten Struktur- und Leistungsdaten (BinDoc
          Analyse-Datensatz).
        </li>
        <li>
          <span
            >Die Lizenznehmerin nutzt diese softwaregestützten Datenanalysen, um
            im Interesse der Patienten Prozesse und Behandlungen zu optimieren
            und die Leistungserbringung qualitativ hochwertig und wirtschaftlich
            und damit existenzsichernd zu ermöglichen bzw. zu verbessern, zur
            Qualitätssicherung, zur Produktverbesserung, für Versorgungsanalysen
            und für Marketingzwecke sowie zur Beratung in diesen
            Bereichen.</span
          >

          <p>
            Ziel der Vereinbarung ist es, der Lizenznehmerin die hierzu
            notwendigen Nutzungsrechte an den als konkretem Lizenzobjekt
            vereinbarten Modulen der Anwendung BinDoc Meta (kurz „BinDoc Meta“)
            inklusive der Anonymisierungsanwendung einzuräumen. Umgekehrt
            gestattet die Lizenznehmerin der BinDoc den durch die Lizenznehmerin
            hochgeladenen BinDoc Analyse-Datensatz im hier beschriebenen Umfang
            in BinDoc Meta zu nutzen Zudem gestattet die Lizenznehmerin BinDoc
            den BinDoc Analyse-Datensatz an Kunden von BinDoc zur Datenanalyse
            im Interesse der Verbesserung medizinischer Produkte, Geräte,
            Anwendungen und Prozesse zu lizenzieren. Dies ermöglicht z.B. einem
            Medizintechnikunternehmen, dessen Produkte die Lizenznehmerin
            einsetzt und welches zugleich Lizenznehmerin von BinDoc ist,ihre
            Prozesse im Zusammenhang mit dem Einsatz dieses Medizinproduktes zu
            analysieren, zu verbessern und sich hierzu beraten zu lassen.
          </p>
        </li>
      </ol>
      <h2 class="text-lg mt-2 font-semibold text-gray-900">
        § 1 Vertragsgegenstand und Nutzungseinräumung
      </h2>
      <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
        <li>
          Vertragsgegenstand ist die Einräumung eines einfachen und auf die
          Dauer dieses Vertrages begrenzten Nutzungsrechts an BinDoc Meta durch
          BinDoc an die Lizenznehmerin. An BinDoc Meta und etwaigen Updates wird
          der Lizenznehmerin ein nicht exklusives und nicht übertragbares
          Nutzungsrecht eingeräumt, BinDoc Meta ausschließlich für die Analyse
          der eigenen Daten zu verwenden. Das Nutzungsrecht beinhaltet BinDoc
          Meta in einem Internet-Browser aufzurufen und zu nutzen, d.h. BinDoc
          Meta wird durch BinDoc und von ihr beauftragte Dienstleister betrieben
          und zur Online-Nutzung bereitgestellt.
        </li>
        <li>
          Bestandteil von BinDoc Meta ist eine browserbasierte Anwendung, die
          lokal im Verantwortungsbereich der Lizenznehmerin gespeicherte
          Struktur- und Leistungsdaten von Behandlungen anonymisiert, so dass
          durch BinDoc kein Personen- und Patientenbezug mehr hergestellt werden
          kann, und verschlüsselt an den Server von BinDoc zur weiteren
          Verarbeitung im hier beschriebenen Umfang übermittelt. Der
          Anonymisierungsprozess wird in der Anlage „Anonymisierte Verarbeitung
          von Datensätzen auf Basis von standardisierten Struktur- und
          Leistungsdaten“ beschrieben. Die Parteien sind sich einig, dass nach
          der Anonymisierung durch die Lizenznehmerin keine personenbezogene
          Datenverarbeitung im Sinne der DSGVO seitens BinDoc vorliegt. BinDoc
          ist nicht willens und in der Lage, den so erzeugten BinDoc
          Analyse-Datensatz zu re-identifizieren und verpflichtet sich dazu
          keinerlei dahingehenden Anstrengungen zu unternehmen. Die gleiche
          Verpflichtung wird BinDoc seinen Lizenznehmern auferlegen.
        </li>
        <li>
          BinDoc übernimmt die Administration, Installation etwaiger Updates und
          Upgrades von BinDoc Meta und BackUps. BinDoc Meta steht an Werktagen
          zwischen 6:00 – 21:00 Uhr mit einer Verfügbarkeit von 99,98% im
          Kalenderjahresdurchschnitt zur Verfügung. Eine weitergehende
          Verfügbarkeit ist möglich, aber nicht Vertragsgegenstand, um
          Wartungsarbeiten etc. durchführen zu können.
        </li>
        <li>
          Die Lizenznehmerin stimmt zu, dass von ihr übermittelte BinDoc
          Analyse-Datensätze in anonymisierter Form ohne erkennbaren Bezug zur
          Lizenznehmerin von BinDoc in eine Benchmarkdatenbank übernommen werden
          dürfen. Die Benchmarkdatenbank steht als Bestandteil von BinDoc Meta
          allen Lizenznehmern zur Verfügung. Die Lizenznehmerin räumt an diesen
          Daten der BinDoc die in Ziff. 2 der Präambel beschriebenen Rechte ein.
          BinDoc ist berechtigt, die anonymisierten und aggregierten Daten ohne
          Bezug zur Lizenznehmerin für eigene Analysezwecke und für
          Publikationen zu verwenden.
        </li>
        <li>
          Nur die Lizenznehmerin sieht den Bezug des von ihr gelieferte BinDoc
          Analyse-Datensatz zu sich in BinDoc Meta in anonymisierter Form.
          Lediglich auf Wunsch der Lizenznehmerin und mit gesonderter
          Vereinbarung kann auch einem anderen Lizenznehmer die Sichtbarkeit der
          Lizenznehmerin als Quelle des BinDoc Analyse Datensatzes angezeigt
          werden.
        </li>
        <li>
          BinDoc stehen als Rechteinhaberin die Rechte nach § 69c UrhG
          (Softwareurheberrecht) zur Vervielfältigung, Bearbeitung, Verbreitung
          und Veröffentlichung an BinDoc Softwarelösungen und dem Quellcode zu.
          Da BinDoc Meta browserbasiert zur Nutzung zur Verfügung gestellt wird,
          ist der Lizenznehmerin eine über die ephemere Vervielfältigung im
          Webbrowser, hinausgehende Nutzung, Speicherung und Kopie von BinDoc
          Meta nicht gestattet, sofern dies nicht gesetzlich anders bestimmt
          ist. Der Lizenznehmerin ist es nicht gestattet, die gemäß Absatz 1
          eingeräumten Nutzungsrechte an Dritte abzutreten, zu übertragen oder
          zu verleasen. Darüber hinaus ist die Gewährung von Unterlizenzen an
          Dritte und die Weitergabe von Benutzername und Passwort und sonstigen
          Zugangsdaten nicht gestattet. Erweiterungen, Änderungen oder sonstige
          Eingriffe jeglicher Art in BinDoc Meta bedürfen der ausdrücklichen
          vorherigen, schriftlichen Einwilligung von BinDoc, es sei denn, es
          handelt sich bei der Änderung bzw. Bearbeitung um eine für die
          vertragsgemäße Nutzung von BinDoc Meta erforderliche Beseitigung eines
          Mangels, mit welcher sich BinDoc in Verzug befindet.
        </li>
        <li>
          Zur vertragsgemäßen Nutzung von BinDoc Meta benötigt die
          Lizenznehmerin einen von ihr zustellenden Internetzugang sowie einen
          aktuellen Internetbrowser der nachfolgenden Marken
          <ul class="list-disc list-inside rounded-xl p-4 pl-8 text-gray-900">
            <li>Edge</li>
            <li>Chrome</li>
            <li>Safari</li>
          </ul>
          Die beste Performance lässt sich zum Zeitpunkt des Vertragsschusses
          mit dem Internetbrowser Chrome erzielen. Internetbrowser und
          Internetzugang sind nicht Gegenstand dieses Vertrages und liegen im
          Verantwortungsbereich der Lizenznehmerin. Die genannten
          Systemvoraussetzungen gelten zum Zeitpunkt des Vertragsabschlusses. Um
          zukünftige Funktionen von BinDoc Meta nutzen zu können, kann es
          erforderlich sein, dass die Lizenznehmerin eine dann aktuelle
          Browser-Version installiert, worauf sie BinDoc hinweisen wird.
        </li>
      </ol>
      <h2 class="text-lg mt-2 font-semibold text-gray-900">
        § 2 Betriebsleistungen und Schulungsservice
      </h2>
      <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
        <li>
          Die Betriebsleistung umfasst die Aufrechterhaltung der
          Funktionsfähigkeit von BinDoc Meta sowie die Installation etwaiger
          Wartungs-Updates, die Behebung von Mängeln sowie die Information zu
          Softwareanpassungen.
        </li>
        <li>
          Kundenindividuelle Wartungs- und Schulungsbedarfe sowie sonstige
          Services können kostenpflichtig zu einer Tagespauschale von 2.000 Euro
          zzgl. USt. vereinbart werden.
        </li>
        <li>
          BinDoc ist zur Aufrechterhaltung der vertraglich vereinbarten
          Beschaffenheit der Software BinDoc Meta während der Vertragslaufzeit
          verpflichtet ("Instandhaltung"). Die vertraglich geschuldete
          Beschaffenheit der Software bestimmt sich nach Maßgabe der Anlage
          „Funktionalität von BinDoc Meta“. Zur Erfüllung der BinDoc obliegenden
          Pflicht zur Instandhaltung wird BinDoc die nach dem Stand der Technik
          erforderlichen Wartungs- und Instandhaltungsmaßnahmen durchführen.
        </li>
        <li>
          BinDoc ist zu einer Änderung oder einer Anpassung der Software nur
          dann verpflichtet, wenn eine solche Änderung oder Anpassung zur
          Instandhaltung der Software nach dem Stand der Technik erforderlich
          ist. Im Übrigen ist BinDoc zu einer Änderung, Anpassung und
          Weiterentwicklung der Software nur dann verpflichtet, wenn die
          Parteien dies gesondert vereinbaren. Ohne eine solche gesonderte
          Vereinbarung ist BinDoc insbesondere nicht zu einer Weiterentwicklung
          der Software verpflichtet. BinDoc ist jedoch gleichwohl zu
          Weiterentwicklungen berechtigt.
        </li>
      </ol>
      <h2 class="text-lg mt-2 font-semibold text-gray-900">
        §3 Vergütung und Zahlung
      </h2>
      <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
        <li>
          Die Lizenznehmerin zahlt an BinDoc für das Nutzungsrecht und die
          Nutzungsmöglichkeit von BinDoc Meta eine gesondert vereinbarte
          Vergütung.
        </li>
      </ol>

      <h2 class="text-lg mt-2 font-semibold text-gray-900">
        §4 Laufzeit und Kündigung
      </h2>
      <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
        <li>
          Der Vertrag beginnt mit der Mitteilung der Zugangsdaten und wird auf
          unbestimmte Zeit geschlossen. Er ist von jeder Partei vorbehaltlich
          abweichender Vereinbarungenmit einer Frist von 3 Monaten zum
          Kalenderjahresende in Textform kündbar.
        </li>
        <li>
          BinDoc ist berechtigt diesen Vertrag oder ein unter diesen Vertrag
          fallendes Nutzungsrecht zu kündigen, falls die Lizenznehmerin
          wesentliche Verpflichtungen aus diesem Vertrag verletzt und auf eine
          entsprechende Abmahnung in Schrift- oder Textform hin die
          Vertragsverletzung nicht innerhalb von 30 Tagen behebt. Sollte sich
          die Vertragsverletzung auf die Zahlung fälliger Entgelte oder anderer
          Forderungen beziehen und die Lizenznehmerin nicht auf eine Abmahnung
          hin die Zahlung innerhalb von 30 Tagen leistet, werden sämtliche noch
          ausstehende Zahlungen für die Restlaufzeit des Vertrages sofort fällig
          und BinDoc kann den Zugang zu BinDoc Meta sperren.
        </li>
        <li>
          Das Recht beider Parteien zur jederzeitigen außerordentlichen und
          fristlosen Kündigung aus wichtigem Grund bleibt unberührt. Ein
          wichtiger Grund liegt insbesondere vor, wenn eine der Parteien
          vorsätzlich oder fahrlässig gegen eine wesentliche Pflicht aus diesem
          Vertrag verstößt und deswegen der kündigenden Partei das Festhalten am
          Vertrag nicht mehr zumutbar ist
        </li>
        <li>
          Nach Beendigung des Vertrages ist die Lizenznehmerin pflichtet, die
          Nutzung von BinDoc Meta einzustellen und etwaige Programmkopien
          (einschließlich der Sicherungskopie) sowie alle überlassenen
          Dokumentationen, Materialien und sonstige Unterlagen an BinDoc
          zurückzugeben oder nachweisbar zu löschen respektive zu vernichten.
          Die Rückgabe erfolgt auf eigene Kosten der Lizenznehmerin.
        </li>
      </ol>

      <h2 class="text-lg mt-2 font-semibold text-gray-900">
        §5 Datenvalidität
      </h2>
      <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
        <li>
          Die in BinDoc Meta verwendeten und zur Verfügung gestellten Daten und
          Informationen basieren neben öffentlichen Quellen auf Recherchen,
          Berechnungen und Prognosen von BinDoc. BinDoc führt regelmäßig
          Validitätsprüfungen der Daten, Informationen, Recherchen, Berechnungen
          und Prognosen durch, ohne für die Vollständigkeit, Richtigkeit und
          Aktualität der aus öffentlichen Quellen bezogenen oder von Dritten
          bereitgestellten Daten verantwortlich zu sein. BinDoc ist für die Wahl
          seiner Datenquellen und die darauf basierenden eigenen Berechnungen,
          nicht jedoch für die Korrektheit der Quelldaten verantwortlich.
        </li>
        <li>
          Die in BinDoc Meta bereitgestellten Daten, Berechnungen und Prognosen
          dienen ausschließlich zu Informationszwecken und stellen keine
          Handlungsaufforderung oder -empfehlung für die Lizenznehmerin dar.
          Verantwortlich für die Interpretation der Daten, Berechnungen und
          Prognosen in Abhängigkeit der eigenen Situation, interner Prozesse und
          lokalen Rahmenbedingungen ist ausschließlich die Lizenznehmerin.
        </li>
      </ol>

      <h2 class="text-lg mt-2 font-semibold text-gray-900">
        §6 Gewährleistung
      </h2>
      <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
        <li>
          Offensichtliche Mängel hat die Lizenznehmerin unverzüglich, spätestens
          jedoch zwei Wochen nach Bereitstellung der vertragsgegenständlichen
          Leistung (Mitteilung der Zugangsdaten zu BinDoc Meta) anzuzeigen.
          Sonstige Mängel sind unverzüglich nach Feststellung oder Entdeckung
          von der Lizenznehmerin der BinDoc anzuzeigen. Die Lizenznehmerin hat
          der Anzeige eine nachvollziehbare Beschreibung des Mangels beizufügen.
          Erfolgt die Anzeige nicht rechtzeitig, gilt der Nutzungsgegenstand in
          Bezug auf diesen Mangel als genehmigt. Die Geltendmachung von
          Gewährleistungsansprüchen ist insoweit ausgeschlossen.
        </li>
        <li>
          Im Falle eines Mangels schuldet BinDoc innerhalb einer angemessenen
          Frist die Beseitigung des Mangels. Diese Mangelbeseitigung kann durch
          die Installation und Bereitstellung eines neuen Updates oder eine
          Erläuterung, wie BinDoc Meta unter Umgehung des Fehlers benutzt werden
          kann, erfolgen.
        </li>
        <li>
          Die Lizenznehmerin ist nicht dazu berechtigt, etwaige
          Minderungsansprüche dadurch geltend zu machen, dass sie den
          Minderungsbetrag von dem Jahreslizenzentgelt eigenständig abzieht. Der
          bereicherungsrechtliche Anspruch, einen aufgrund berechtigter
          Minderungsansprüche zuviel gezahlten Betrag zurückzufordern, bleibt
          hiervon unberührt.
        </li>
        <li>
          Im Falle des Fehlschlags der geschuldeten Mangelbeseitigung ist die
          Lizenznehmerin zur außerordentlichen Kündigung dieses Vertrages
          berechtigt. Ein Fehlschlag der Mangelbeseitigung liegt insbesondere
          dann vor, wenn die Mangelbeseitigung für BinDoc unmöglich ist, wenn
          BinDoc die Mängelbeseitigung verweigert oder wenn die
          Mangelbeseitigung durch BinDoc aus sonstigen Gründen für die
          Lizenznehmerin unzumutbar ist.
        </li>
        <li>
          Probleme, die aufgrund der Verwendung eines zu alten Internetbrowsers
          (siehe § 1 Abs. 2) bei der Lizenznehmerin auftreten, stellen keinen
          Mangel dar.
        </li>
        <li>
          Sämtliche Gewährleistungsansprüche verjähren in zwei Jahren von der
          Bereitstellung an. Zwingende gesetzliche Verjährungsregelungen bleiben
          unberührt.
        </li>
      </ol>

      <h2 class="text-lg mt-2 font-semibold text-gray-900">§7 Haftung</h2>
      <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
        <li>
          BinDoc haftet unbeschränkt:
          <ul class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
            <li>bei Arglist, Vorsatz oder grober Fahrlässigkeit;</li>
            <li>im Rahmen einer von ihr ausdrücklich übernommenen Garantie;</li>
            <li>
              für Schäden aus der Verletzung des Lebens, des Körpers oder der
              Gesundheit;
            </li>
            <li>
              für die Verletzung einer wesentlichen vertraglichen Pflicht, deren
              Erfüllung die ordnungsgemäße Durchführung dieses
              Software-Mietvertrags überhaupt erst ermöglicht und auf deren
              Einhaltung die Lizenznehmerin regelmäßig vertraut und vertrauen
              darf ("Kardinalpflicht"), jedoch begrenzt auf den bei Eintritt des
              Vertragsschlusses vernünftigerweise zu erwartendem Schaden sowie
            </li>
            <li>nach den Vorschriften des Produkthaftungsgesetzes.</li>
          </ul>
          <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
            <li>
              Im Übrigen ist eine Haftung von BinDoc ausgeschlossen.
              Insbesondere haftet BinDoc nicht für bereits bei Vertragsschluss
              vorhandene Mängel, soweit kein Fall des Abs. 1 gegeben ist.
            </li>
            <li>
              Die vorstehenden Haftungsregeln gelten entsprechend für das
              Verhalten von und Ansprüchen gegen Mitarbeiter, gesetzliche
              Vertreter und Erfüllungsgehilfen von BinDoc.
            </li>
            <li>
              Sämtliche Schadensersatzansprüche verjähren in zwei Jahren von der
              Bereitstellung an. Zwingende gesetzliche Verjährungsregelungen
              bleiben unberührt.
            </li>
          </ol>
        </li>
      </ol>

      <h2 class="text-lg mt-2 font-semibold text-gray-900">
        §8 Änderungen oder Ergänzungen des Vertrages
      </h2>
      <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
        <h3 class="text-base mt-2 font-semibold text-gray-900">
          Änderungsangebot
        </h3>
        <li>
          Änderungen dieser Allgemeinen Geschäftsbedingungen werden der
          Lizenznehmerin in Textform angeboten. BinDoc kann die Änderungen auf
          einem elektronischen Kommunikationsweg anbieten.
        </li>
        <h3 class="text-base mt-2 font-semibold text-gray-900">
          Annahme durch die Lizenznehmerin
        </h3>
        <li>
          Die von BinDoc angebotenen Änderungen werden nur wirksam, wenn die
          Lizenznehmerin diese annimmt, gegebenenfalls im Wege der nachfolgend
          geregelten Zustimmungsfiktion.
        </li>
        <h3 class="text-base mt-2 font-semibold text-gray-900">
          Annahme durch die Lizenznehmerin im Wege der Zustimmungsfiktion
        </h3>
        <li>
          Das Schweigen der Lizenznehmerin gilt nur dann als Annahme des
          Änderungsangebotes (Zustimmungsfiktion), wenn
          <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
            <li>
              das Änderungsangebot von BinDoc erfolgt, um die Übereinstimmung
              der vertraglichen Bestimmungen mit einer veränderten Rechtslage
              wiederherzustellen, weil eine Bestimmung der Allgemeinen
              Geschäftsbedingungen
              <ul
                class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900"
              >
                <li>
                  aufgrund einer Änderung von Gesetzen, einschließlich
                  unmittelbar geltender Rechtsvorschriften der Europäischen
                  Union, nicht mehr der Rechtslage entspricht oder
                </li>
                <li>
                  durch eine rechtskräftige gerichtliche Entscheidung, auch
                  durch ein Gericht erster Instanz, unwirksam wird oder nicht
                  mehr verwendet werden darf oder
                </li>
                <li>
                  aufgrund einer verbindlichen Verfügung einer für BinDoc
                  zuständigen nationalen oder internationalen Behörde nicht mehr
                  mit den (aufsichts-)rechtlichen Verpflichtungen von BinDoc in
                  Einklang zu bringen ist
                </li>
              </ul>
            </li>
            <li>
              die Lizenznehmerin das Änderungsangebot von BinDoc nicht vor dem
              vorgeschlagenen Zeitpunkt des Wirksamwerdens der Änderungen
              abgelehnt hat. BinDoc wird der Lizenznehmerin im Änderungsangebot
              auf die Folgen ihres Schweigens hinweisen.
            </li>
          </ol>
        </li>
        <h3 class="text-base mt-2 font-semibold text-gray-900">
          Kündigungsrecht der Lizenznehmerin bei der Zustimmungsfiktion
        </h3>
        <li>
          Macht BinDoc von der Zustimmungsfiktion Gebrauch, kann die
          Lizenznehmerin den von der Änderung betroffenen Vertrag vor dem
          vorgeschlagenen Zeitpunkt des Wirksamwerdens der Änderungen auch
          fristlos und kostenfrei kündigen. Auf dieses Kündigungsrecht wird
          BinDoc die Lizenznehmerin in ihrem Änderungsangebot besonders
          hinweisen.
        </li>
        <h3 class="text-base mt-2 font-semibold text-gray-900">
          Zustimmungsfiktion bei Lizenznehmern, die keine Verbraucher sind
        </h3>
        <li>
          Sofern die Lizenznehmerin kein Verbraucher ist, findet abweichend von
          den Absätzen 3a und 4 bei jedem Änderungsangebot von BinDoc die
          Zustimmungsfiktion bezüglich der Annahmeerklärung der Lizenznehmerin
          Anwendung; die Maßgaben nach den Absätzen 1, 2, 3b und 5 dieses
          Abschnitts bleiben unberührt. Insbesondere für die Änderung von
          Lizenzverträgen wird die Zustimmungsfiktion hiermit vereinbart. Das
          Änderungsangebot nach § 8.1. kann per E-Mail oder E-Mail-Hinweis auf
          ein Webseitenformular erfolgen sowie in den LogIn-Prozess zum
          Online-Account von BinDoc Meta oder einem speziellen Modul von BinDoc
          Meta integriert werden.
        </li>
      </ol>

      <h2 class="text-lg mt-2 font-semibold text-gray-900">
        §9 Allgemeine Bestimmungen
      </h2>
      <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
        <li>
          Für die Rechte und Pflichten der Parteien sind allein die Bedingungen
          dieses Vertrages maßgeblich. Mündliche Nebenabreden zu diesem Vertrag
          bestehen nicht.
        </li>
        <li>
          Allgemeine Geschäftsbedingungen der Lizenznehmerin finden keine
          Anwendung, auch wenn in etwaigen Angeboten der Lizenznehmerin, der
          Bestellung, der Bestellannahme oder sonstigen Unterlagen auf deren
          Geltung hingewiesen wird.
        </li>
        <li>Der Vertrag bindet auch die Rechtsnachfolger der Parteien.</li>
        <li>
          Der Vertrag kommt durch
          <ul class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
            <li>
              Unterschrift beider Parteien auf ein oder jeweils ein identisches
              Vertragsexemplar, welches die Parteien austauschen, oder
            </li>
            <li>
              durch Anklicken „ich/wir akzeptiere/n die allgemeinen
              Geschäftsbedingungen“ im Bestellprozess auf der BinDoc Webseite
              wobei ich/wir zugleich bestätige/n nicht als Privatperson, sondern
              als Unternehmen zu handeln,
            </li>
          </ul>
          zustande.
        </li>
        <li>
          Sofern BinDoc im Rahmen dieses Vertrages Krankenhausdaten zugänglich
          gemacht werden, wird BinDoc das Geschäftsgeheimnis wahren und
          verpflichtet sich – sofern überhaupt anwendbar - zur Beachtung des
          Berufsgeheimnisses, § 203 StGB, und des Datenschutzrechts. BinDoc
          verpflichtet sich ferner alle ihr zugänglichen personenbezogenen
          Daten, insbesondere Accountdaten der Nutzer / Mitarbeiter der
          Lizenznehmerin ausschließlich zur Kundenbetreuung der Lizenznehmerin
          oder sonstigen berechtigten eigenen Geschäftsinteressen (z.B.
          Rechnungsstellung) zu verarbeiten. Alle Mitarbeiter der BinDoc wurden
          auf die Einhaltung des Datenschutzes, der Wahrung der Vertraulichkeit
          geschäftlicher Daten und des Berufsgeheimnisses gemäß § 203 StGB
          verpflichtet
        </li>
        <li>
          Der Vertrag unterliegt deutschem Recht. Als Gerichtsstand für alle
          Streitigkeiten aus diesem Vertrag gilt das für den Sitz der BinDoc
          GmbH zuständige Gericht.
        </li>
      </ol>

      <h2 class="text-lg mt-2 font-semibold text-gray-900">
        §10 Salvatorische Klausel
      </h2>
      <ol class="list-inside list-disc rounded-xl p-4 pl-8 text-gray-900">
        <li>
          Sollten eine oder mehrere Bestimmungen dieses Vertrages unwirksam oder
          undurchführbar sein oder nach Vertragsschluss unwirksam oder
          undurchführbar werden, bleibt davon die Wirksamkeit des Vertrages im
          Übrigen unberührt. Die Parteien verpflichten sich, die unwirksame
          Bestimmung durch eine dem wirtschaftlichen Zweck möglichst nahe
          kommende Regelung zu ersetzen.
        </li>
      </ol>

      <h2 class="text-lg mt-2 font-semibold text-gray-900">Anlage</h2>
      <a
        class="p-button p-button-primary p-button-text"
        target="_blank"
        href="https://www.bindoc.de/hubfs/Anonymisierte%20Verarbeitung%20von%20Datens%C3%A4tzen%20auf%20Basis%20von%20Struktur-%20und%20Leistungsdaten.pdf"
      >
        Anonymisierte Verarbeitung von Datensätzen auf Basis von Struktur- und
        Leistungsdaten (BinDoc Analyse-Datensatz)
      </a>
    </div>

    <div class="flex flex-row-reverse">
      <p-button severity="secondary" (click)="dialogRef.close()">
        Schließen
      </p-button>
    </div>
  `,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Button],
})
export class KostDataImportDeNewTermsAndConditionsDialogComponent {
  readonly dialogRef =
    inject<
      DynamicDialogRef<KostDataImportDeNewTermsAndConditionsDialogComponent>
    >(DynamicDialogRef);
}
